import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import '../styles/NotFound.css';

const NotFound = ({ lang = {} }) => {
  return (
    <section className="notfound-page">
      <div className="container">
        <motion.div
          className="notfound-wrapper"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div className="notfound-terminal">
            <span className="notfound-prompt">root@ispclub:~/#</span>
            <span className="notfound-cmd">./ispclub --route /not-found</span>
          </div>
          <h1 className="notfound-code">404</h1>
          <h2 className="notfound-title">{lang.NOTFOUND_TITLE || 'Page Not Found'}</h2>
          <p className="notfound-desc">
            {lang.NOTFOUND_DESC || "The page you're looking for doesn't exist or you don't have permission to access it."}
          </p>
          <div className="notfound-actions">
            <Link to="/home" className="btn btn-primary">
              {lang.NOTFOUND_HOME || 'Back to Home'}
            </Link>
            <Link to="/dashboard" className="btn btn-outline">
              {lang.NOTFOUND_DASHBOARD || 'Go to Dashboard'}
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default NotFound;
